import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  heading: {
    width: '100%',
    height: '57px',
    borderRadius: '6px',
    '@media (max-width: 640px)': {
      height: '81px',
    },
  },

  fieldContainer: {
    marginBottom: theme.spacing(3),
    '@media (max-width: 340px)': {
      flex: 1,
    },
  },

  inputField: {
    maxWidth: '782px',
    height: '76px',
    borderRadius: '6px',
  },

  phoneContainer: {
    gap: '16px',
  },

  phoneField: {
    width: '150px',
    height: '76px',
    borderRadius: '6px',
  },

  extField: {
    width: '67px',
    height: '76px',
    borderRadius: '6px',
  },

  secondaryPhoneContainer: {
    gap: '16px',
  },

  cityStateContainer: {
    marginBottom: theme.spacing(3),
    maxWidth: '782px',
    gap: '16px',
  },

  cityStateContainerField: {
    height: '76px',
    borderRadius: '6px',
    width: '100%',
  },

  cityContainer: {
    flex: '3 1 0',
    '@media (max-width: 640px)': {
      flex: '15 1 0',
    },
    '@media (max-width: 400px)': {
      flex: '12 1 0',
    },
  },

  stateContainer: {
    flex: '1 1 0',
    '@media (max-width: 640px)': {
      flex: '7 1 0',
    },
    '@media (max-width: 400px)': {
      flex: '7 1 0',
    },
  },

  zipContainer: {
    flex: '1 1 0',
    '@media (max-width: 640px)': {
      flex: '9 1 0',
    },
    '@media (max-width: 400px)': {
      flex: '9 1 0',
    },
  },

  button: {
    width: '169px',
    height: '44px',
    borderRadius: '6px',
    marginBottom: '24px',
    '@media (max-width: 640px)': {
      height: '104px',
      width: '100%',
    },
  },
}));
